import BaseDTO from '../base/BaseDTO';
import Address from '../shared/Address';

export default class Manufacturer extends BaseDTO {
    public name: string | undefined;
    public address: Address | undefined;
    public mail: string | undefined;
    public note: string | undefined;
    public contractExpirationDate: string | undefined;

    constructor(data: { [key: string]: any }) {
        super(data);
        this.name = data['name'] || undefined;
        this.address = data['address']
            ? new Address(data['address'])
            : undefined;
        this.mail = data['mail'] || undefined;
        this.note = data['note'] || undefined;
        this.contractExpirationDate = data['contractExpirationDate'] || undefined;
    }
}
